import { HttpHandler } from './HttpHandler';
import { environment } from '../enviroments';
import { SpecialistReview } from '@mindly/ui-components';

export const getReviewsByIds = async (ids: string[]): Promise<SpecialistReview[]> => {
  const uniqueIds = Array.from(new Set(ids.filter((id) => id.trim() !== '')));

  const { data: reviewsData } = await HttpHandler<{ data: SpecialistReview[] }>({
    method: 'GET',
    url: `${environment.SPECIALIST_APP_URL}/reviews/client/by-ids/`,
    params: { 'ids[]': uniqueIds },
  });

  return reviewsData.data;
};
